var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLotto)?_c('LottoBetSlip',{staticClass:"betslip-preview",on:{"close":function($event){return _vm.$emit('close')}}}):_c('BetSlip',_vm._b({staticClass:"betslip-preview",on:{"close":function($event){return _vm.$emit('close')}}},'BetSlip',_vm.modalData,false))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46aaf4fc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/modals/modals/betSlipPreview/BetSlipPreviewModal.vue
// module id = 2616
// module chunks = 0